import React from 'react';
import { SelectionListMultiSelect } from '@shared/components/SelectionListMultiSelect';
import { CERTIFICATION_DOMAIN } from '../../../../AppraiserForm/constants/certificationDomain';

/**
 * @typedef {object} DomainSelectionProps
 * @property {Array<number>} [selectedDomains]
 * @property {(selectedIds: Array<number>) => void} [handleDomainSelection]
 * @property {boolean} [loading]
 * @property {boolean} [hasError]
 * @property {boolean} [disabled]
 */

/**
 * @param {DomainSelectionProps} props
 */
const DomainSelection = props => {
  const {
    selectedDomains,
    handleDomainSelection,
    loading,
    hasError = false,
    disabled = false
  } = props;

  return (
    <div className='option-selector'>
      <SelectionListMultiSelect
        id='domain-selector'
        placeholder='Select Domain(s)'
        multiSelect
        options={domainOptions}
        value={selectedDomains}
        onChange={handleDomainSelection}
        loading={loading}
        disabled={disabled}
        hasError={hasError}
      />
    </div>
  );
};

const domainOptions = [
  {
    label: 'ASC',
    value: CERTIFICATION_DOMAIN.ASC
  },
  {
    label: 'DATA',
    value: CERTIFICATION_DOMAIN.DATA
  },
  {
    label: 'DEV',
    value: CERTIFICATION_DOMAIN.DEV
  },
  {
    label: 'HM',
    value: CERTIFICATION_DOMAIN.HM
  },
  {
    label: 'PPL',
    value: CERTIFICATION_DOMAIN.PPL
  },
  {
    label: 'SAF',
    value: CERTIFICATION_DOMAIN.SAF
  },
  {
    label: 'SEC',
    value: CERTIFICATION_DOMAIN.SEC
  },
  {
    label: 'SVC',
    value: CERTIFICATION_DOMAIN.SVC
  },
  {
    label: 'SPM',
    value: CERTIFICATION_DOMAIN.SPM
  },
  {
    label: 'VRT',
    value: CERTIFICATION_DOMAIN.VRT
  }
];

export default DomainSelection;
